import { RootState } from "../reducers";
import { ErrorState } from "../reducers/errorReducers";

export const CurrentErrorSelector = (state: RootState): ErrorState =>
  state.currentError;
